import React, { JSX } from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';

import { formatNumber, formatThresholdHint, isAlert, NormalizedThreshold } from '../utils/metrics';

interface Props {
  label: string;
  color: string;
  value: number;
  threshold: NormalizedThreshold;
}

const ChartTooltipEntry = ({ label, color, value, threshold }: Props): JSX.Element => {
  const alert = isAlert(threshold, value);
  const hint = alert ? formatThresholdHint(threshold, value) : '';

  return (
    <HStack spacing={2} fontSize="xs">
      <Box w="8px" h="8px" borderRadius="full" bg={color} flexShrink={0} />
      <Text color="grey.500">{label}:</Text>
      <Text fontWeight="medium" color={alert ? 'red.500' : undefined}>
        {formatNumber(value)}
        {hint && (
          <Text as="span" fontWeight="normal" color="red.500">
            {hint}
          </Text>
        )}
      </Text>
    </HStack>
  );
};

export default ChartTooltipEntry;
